import api from './axios.service';
const axios = api;

const getSettings = async () => {
    try {
        let response = await axios.get(`/settings`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const getSetting = async (key) => {
    try {
        let response = await axios.get(`/settings/${key}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const addSetting = async (payload) => {
    try {
        let response = await axios.post(`/settings`, payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const putSetting = async (key, payload) => {
    try {
        let response = await axios.put(`/settings/${key}`, payload);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

const deleteSetting = async (key) => {
    try {
        let response = await axios.delete(`/settings/${key}`);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    getSettings,
    getSetting,
    addSetting,
    putSetting,
    deleteSetting
};
